import { render, staticRenderFns } from "./ScoreSettingCreate.vue?vue&type=template&id=a1c3248e"
import script from "../../../controllers/custom/score_setting/score-setting-create.js?vue&type=script&lang=js&external"
export * from "../../../controllers/custom/score_setting/score-setting-create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports